var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useCallback, useEffect } from "react";
import Grid from "@mui/material/Grid";
import { RightSideContent } from "./rightSideText";
import styled from "@mui/material/styles/styled";
import { SelectMember } from "./components/SelectMember";
import { CheckList } from "./components/CheckList";
import { getAllFamilyMember } from "./components/CheckList/ListForm/api/checkListAPI";
import { Button } from "../Button";
import { submitData } from "./components/CheckList/ListForm/api/ReimbursementHandler";
import { useCommonLoader } from "../Loader";
import { Box, Dialog, DialogActions, DialogContent, DialogTitle, } from "@mui/material";
import { modalFields } from "./components/CheckList/data";
import { CardWrapper } from "../CardWrapper";
import config from "../../assests/config";
const StyleWrapper = styled(Box)(() => {
    return {
        "#select-fields": {
            marginBottom: 20,
        },
        ".save": {
            marginRight: 10,
        },
        "#product-wrapper_component .MuiFormLabel-root": {
            zIndex: 0,
        },
        ".MuiInputBase-root": {
            borderRadius: "2px !important",
        },
        '.RightSideContent': {
            borderLeft: '1px solid rgb(227, 227, 227)'
        }
    };
});
/**
 *
 * @Stateparam selectedmemberData: Value comes from "select member" dropdown
 * @returns
 */
export const ReimbursementUpdate = (props) => {
    const [success, setSuccess] = React.useState("");
    const { setLoading, unSetLoading } = useCommonLoader();
    const [familyMemberData, setFamilyData] = React.useState({
        allMembers: [],
        selectedmemberData: null,
        selectedReference: props.selectedReference,
    });
    const [dataNotFound, setDataNotFound] = React.useState(false);
    const fetchAllFamilyMember = () => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b;
        try {
            setLoading();
            const memberData = yield getAllFamilyMember({
                memberid: (_a = props.selectedReference) === null || _a === void 0 ? void 0 : _a.memberId,
            });
            if (memberData.message === "Network Error") {
                setDataNotFound(true);
            }
            else {
                setDataNotFound(false);
            }
            setFamilyData(Object.assign(Object.assign(Object.assign({}, familyMemberData), memberData), { selectedmemberData: Object.assign(Object.assign({}, memberData.selectedmemberData), { serviceDate: ((_b = props.selectedReference) === null || _b === void 0 ? void 0 : _b.serviceDate) || "" }) }));
            unSetLoading();
        }
        catch (error) {
            setDataNotFound(true);
            unSetLoading();
            console.log(error);
        }
    });
    useEffect(() => {
        setFamilyData((prevState) => {
            return Object.assign(Object.assign({}, prevState), { selectedReference: props.selectedReference });
        });
        fetchAllFamilyMember();
    }, []);
    const actionsHandler = (btnInfo) => {
        return () => __awaiter(void 0, void 0, void 0, function* () {
            if (!familyMemberData.selectedmemberData)
                return;
            const status = btnInfo.label === "SUBMIT" ? "SUBMITTED" : "PENDING";
            try {
                setLoading();
                yield submitData({
                    selectedMember: familyMemberData.selectedmemberData,
                    status,
                    reimbursementFlow: familyMemberData.selectedReference, // Parent data(My Reimbursement -> update -> row data is this(selectedReference))
                });
                unSetLoading();
                setSuccess(btnInfo.label);
            }
            catch (error) {
                unSetLoading();
                console.log("actionsHandler error::::: ", error);
            }
        });
    };
    const updateSelectedMember = useCallback((key, value) => {
        if (key === "memberName") {
            const findMemberData = familyMemberData.listMember.find((res) => res.firstName + " " + res.lastName == value);
            findMemberData.memberName = value;
            const allFields = Object.values(modalFields)
                .map(({ fields }) => [...fields.map(({ name }) => name)])
                .flat();
            allFields.push("paymentProof", "providerSuperbill");
            allFields.map((name) => (familyMemberData.selectedReference[name] = ""));
            return setFamilyData(Object.assign(Object.assign({}, familyMemberData), { selectedmemberData: findMemberData, selectedReference: Object.assign(Object.assign({}, familyMemberData.selectedReference), { [key]: value }) }));
        }
        setFamilyData(Object.assign(Object.assign({}, familyMemberData), { selectedReference: Object.assign(Object.assign({}, familyMemberData.selectedReference), { [key]: value }) }));
    }, [familyMemberData]);
    useEffect(() => {
        setFamilyData((prevState) => (Object.assign(Object.assign({}, prevState), { selectedReference: props.selectedReference })));
    }, [props.selectedReference]);
    if ((!familyMemberData.selectedReference ||
        !familyMemberData.allMembers.length) &&
        dataNotFound)
        return (React.createElement(Grid, { container: true, spacing: 2, justifyContent: "center", alignItems: "center", sx: { paddingTop: "10%" } }, config.errorMessages.DATA_NOT_FOUND));
    return (React.createElement(StyleWrapper, null,
        React.createElement(CardWrapper, { Component: () => {
                var _a, _b;
                return (React.createElement(Grid, { container: true, spacing: 2 },
                    React.createElement(Grid, { item: true, xs: 12, sm: 8 },
                        React.createElement(Grid, { id: "select-fields" },
                            React.createElement(Grid, { container: true, spacing: 2, className: "reimbursment-date-member" },
                                React.createElement(Grid, { item: true, xs: 6, sm: 4 },
                                    React.createElement(SelectMember, { list: (familyMemberData === null || familyMemberData === void 0 ? void 0 : familyMemberData.allMembers) || [], disabled: (_a = familyMemberData.selectedReference) === null || _a === void 0 ? void 0 : _a.memberId, value: ((_b = familyMemberData.selectedReference) === null || _b === void 0 ? void 0 : _b.memberName) || "", updateSelectedMember: updateSelectedMember })),
                                React.createElement(Grid, { item: true, xs: 6, sm: 4 })),
                            React.createElement(CheckList, Object.assign({}, props, { selectedReference: familyMemberData.selectedReference, setModalValues: (val) => {
                                    if (val) {
                                        setFamilyData(Object.assign(Object.assign({}, familyMemberData), { selectedReference: Object.assign(Object.assign({}, familyMemberData.selectedReference), val) }));
                                    }
                                } })))),
                    React.createElement(Grid, { item: true, xs: 12, sm: 4, className: 'RightSideContent' },
                        React.createElement(RightSideContent, null))));
            }, buttons: buttons.map((btn) => {
                var _a;
                let allValues = Object.values(modalFields)
                    .map(({ fields }) => [...fields.map(({ name }) => name)])
                    .flat();
                allValues.push("paymentProof", "providerSuperbill");
                allValues = allValues.find((data) => {
                    return !familyMemberData.selectedReference[data];
                });
                const disable = btn.label === "SUBMIT"
                    ? Boolean(allValues)
                    : !((_a = familyMemberData.selectedReference) === null || _a === void 0 ? void 0 : _a.serviceDate);
                return Object.assign(Object.assign({}, btn), { disabled: disable, onClick: actionsHandler(btn) });
            }), title: "REIMBURSEMENT REQUEST", showChatIcon: false, footerText: "" }),
        React.createElement(Grid, { container: true },
            React.createElement(Dialog, { open: Boolean(success), "aria-labelledby": "alert-dialog-title", "aria-describedby": "alert-dialog-description" },
                React.createElement(DialogTitle, { id: "alert-dialog-title" }, "Message"),
                React.createElement(DialogContent, null, `Your reimbursement request has been ${success === "SUBMIT" ? "submitted" : "saved"}  successfully.`),
                React.createElement(DialogActions, null,
                    React.createElement(Button, { label: "OK", onClick: () => {
                            props.onCallback();
                            setSuccess("");
                        } }))))));
};
const buttons = [
    {
        label: "SAVE",
        size: "large",
        variant: "outlined",
        type: "button",
        className: "save",
    },
    {
        label: "SUBMIT",
        size: "large",
        variant: "outlined",
        type: "button",
        className: "submit",
    },
];
